import script from "./employee-details.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-details.vue?vue&type=script&setup=true&lang=js"

import "./employee-details.vue?vue&type=style&index=0&id=5555c89b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5555c89b"]])

export default __exports__